import {connect} from 'react-redux'
import Gallery from '../components/Gallery.jsx'

// Map Redux state to component props
function mapStateToProps (state) {
  return {
    // content: state.page.content
  }
}

// Connected Component
const GalleryContainer = connect(
  mapStateToProps
)(Gallery)

export default GalleryContainer
